<template>
  <div id="menu">    
    <el-menu :default-active="$route.path" router unique-opened class="el-menu-vertical-demo" style="border:none"  :collapse="isCollapse" :collapse-transition="isCollapseTransition">
      <div style="display: flex;justify-content:flex-end;padding:20px 25px 0px 0px;">
         <i class="el-icon-s-fold" style="font-size:18px;cursor:pointer"   @click="handMenuSelect('collapse')" v-if="!isCollapse"></i>
         <i class="el-icon-s-unfold" style="font-size:18px;cursor:pointer" @click="handMenuSelect('spread')" v-if="isCollapse"></i>
      </div>
      <template v-for="(item, index) in routeList" v-if="!item.hidden">
        <!--二级菜单-->
        <template v-if="!item.leaf">

          <el-submenu :index="index+''">
            <template slot="title">
             <i :class="item.iconCls"></i>          
              <span>{{item.name}}</span>  <el-badge v-if="item.num>0" is-dot class="item-badge"></el-badge>      
            </template>
            <el-menu-item-group>
              <el-menu-item v-if="!child.hidden" :index="child.path+'/?engine='+child.api" :key="index"
                v-for="(child, index) in item.children"> 
                  {{child.name}} <el-badge v-if="child.num>0" is-dot class="item-badge"></el-badge> 
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </template>

        <!--一级菜单-->
        <template v-else>
          <el-menu-item :index="child.path" :key="index" v-for="(child, index) in item.children">
              <i :class="child.iconCls"></i>
            <span slot="title">{{child.name}}</span>
          </el-menu-item>
        </template>
        <!-- <subMenu v-else :data="item" :key="key"></subMenu> -->
      </template>

    </el-menu>
  </div>
</template>

<script>
  export default {
    name: "NavMenu",
    props: {

    },
    data() {
      return {
        routeList:[],
        isCollapse:false,
        isCollapseTransition:false,
      };
    },
    mounted: function() {
      this.initPage();
      this.timer = setInterval(() => {
          //setTimeout(this.queryInfo, 0)
      }, 2*1000)
    },
    computed: {
    },
    methods: {
      initPage(){ 

        setTimeout(this.queryInfo, 1000);
  
        if(JSON.parse(localStorage.getItem("routeListStorage"))){
          this.routeList=JSON.parse(localStorage.getItem("routeListStorage"));
        }
    
        let muenType=sessionStorage.getItem("menu");
        this.handMenuSelect(muenType);

      },
      handMenuSelect(type) {
        sessionStorage.setItem("menu",type);
        if(type=="spread"){
            var e = document.getElementsByClassName("panda-container");
            e[0].classList.remove("is-menu-collapse");
            e[0].classList.add("is-menu-spread");

            var e = document.getElementsByClassName("panda-sidebar");
            e[0].classList.remove("is-menu-collapse");
            e[0].classList.add("is-menu-spread");
      
            var e = document.getElementsByClassName("panda-body");
            e[0].classList.remove("is-body-collapse");
            e[0].classList.add("is-body-spread");

            this.isCollapse=false;
        }else{
            var e = document.getElementsByClassName("panda-container");
            e[0].classList.remove("is-menu-spread");
            e[0].classList.add("is-menu-collapse");

            var e = document.getElementsByClassName("panda-sidebar");
            e[0].classList.remove("is-menu-spread");
            e[0].classList.add("is-menu-collapse");

            var e = document.getElementsByClassName("panda-body");
            e[0].classList.remove("is-body-spread");
            e[0].classList.add("is-body-collapse");
            this.isCollapse=true;
        }
      },

      queryInfo(){

        if(this.routeList && this.routeList.length==0){
          this.routeList=this.$store.state.routeList;
          localStorage.setItem("routeListStorage",JSON.stringify(this.$store.state.routeList));    
        }else{
          this.routeList=JSON.parse(localStorage.getItem("routeListStorage"));
        }
  
       
      }

    }
  };
</script>

<style>
.item-badge{
  padding-top:0px;
  margin-right:0px;
}
.is-menu-spread{
  width:190px ! important;
}
.is-menu-collapse{
  width:65px;
}

.is-body-spread{
  margin-left:190px;
}
.is-body-collapse{
   margin-left:65px;
 }

.el-menu-vertical-demo {
    height: 100vh;
    overflow-y: scroll;
  }
  
.el-menu-vertical-demo::-webkit-scrollbar {
      display: none;   
  }

  .logo {
    display: flex;
    width: 100%;
    height: 88px;
    justify-content: center;
    align-items: center;

  }

  .logo img {
    width: 90px;
    height: 46px;
  }

  .el-menu-item {
    display: flex;
    align-items: center;
    padding: 0;
    /*    border-top: 1px solid rgba(129, 138, 150, 0.1);
    border-bottom: 1px solid rgba(129, 138, 150, 0.1); */
  }

  .el-menu-item-group ul li a {
    width: 100%;
    color: white;
  }

  .el-menu-item a {
    width: 100%;
    font-size: 14px;
    display: block;
    color: #818A96;
  }

  .el-menu-item span a {
    color: #818A96;
  }

  .router-link-active {
    color: #1989FA !important;
  }

  .el-submenu__title {
    display: flex;
    align-items: center;
  }

  .el-submenu__title span,
  .el-menu-item span a {
    font-size: 14px;
  }

  .el-submenu__title i,
  .el-menu-item i {
    margin-right: 8px;
    color: #818A96 !important;
  }

  .el-menu-item.is-active i {
    color: #1989FA !important
  }

  .el-menu-item.is-active a {
    color: #1989FA !important
  }

  .el-menu-item,
  .el-menu-item,
  .el-submenu__title {
    width: 100%;
    height: 48px;
    padding: 0;
  }

  .el-menu-item.is-active {
    border-right: 2px solid #1989FA;
  }

  .el-submenu .el-menu-item {
    min-width: 160px;
  }

  .panda-sidebar .el-menu-item-group li {
    min-width: 160px;
  }
</style>



// WEBPACK FOOTER //
// src/components/nav-menu.vue